import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { UserData } from '../UserAndProfile/UserContext';
import ReferralProgressItem from './ReferralProgressItem';

interface ReferredUsersListProps {
  referredUsers: UserData['referredUsers'];
}

const ReferredUsersList: React.FC<ReferredUsersListProps> = ({ referredUsers }) => {

  // Sort referrals: most recent first
  const sortedReferrals = [...referredUsers].sort((a, b) => 
    new Date(b.invitedDate).getTime() - new Date(a.invitedDate).getTime()
  );

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Your Referrals:
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {sortedReferrals.map((referral) => (
          <ReferralProgressItem 
            key={referral.referralId} 
            referral={referral} 
          />
        ))}
      </Box>
    </Box>
  );
};

export default ReferredUsersList; 